export const iconPrefix = {
    SOLID: 'SOLID',
    LIGHT: 'LIGHT',
    REGULAR: 'REGULAR',
}

export const signatureTypes = {
    1: 'SIGNATURE_ONLY',
    2: 'CHECKBOX_ONLY',
    3: 'CHECKBOX_AND_SIGNATURE',
    0: 'NONE'
}

export const signatureTypesEnum = {
    'SIGNATURE_ONLY': 1,
    'CHECKBOX_ONLY': 2,
    'CHECKBOX_AND_SIGNATURE': 3,
    'NONE': 0
}

export const questionTypes = {
    YES_NO: 'questionYesNo',
    YES_NO_ADV: 'questionYesNoAdv',
    MULTI_CHOICE: 'questionMultipleChoice',
    OPEN: 'questionOpen',
}

export const bookingTypes = {
    PAST: 'past',
    CANCEL_SCHEDULE_USER: 'cancelScheduleUser',
    CANCEL_WAIT_LIST: 'cancelWaitList',
    INSERT_SCHEDULE_USER: 'insertScheduleUser',
    INSERT_STAND_BY: 'insertStandby',
    INFO: 'info',
    SUCCESS_OPTIONS: 'successOptions',
    INVITE_FRIENDS: 'inviteFriends',
    ADD_TO_CALENDAR: 'addToCalendar',
}

export const sessionTypes = {
    CLASS: 'class',
    COURSE: 'workshop',
    APPOINTMENT: 'appointment',
    HUGIM: 'hugim'
}

//FOR OLD APP FORMATTING! DON'T USE IF YOU CAN GET THE NAME FROM THE SERVER! (ALL NEW FETCHES!)
export const sessionTypesById = {
    '1': sessionTypes.CLASS,
    '2': sessionTypes.APPOINTMENT,
    '3': sessionTypes.COURSE,
    '4': sessionTypes.HUGIM
}

export const membershipTypes = {
    PUNCH_CARD: 'session',
    PLAN: 'plan',
    PAY_FOR_SLOT: 'service',
    COURSE: 'workshop',
    TRIAL: 'trial'
}

export const customFieldTypes = {
    TEXT: 'text',
    SELECT: 'select',
    BOOLEAN: 'boolean',
    NUMBER: 'number',
    DATE: 'date',
    PHONE: 'phone'
}

export const paymentSuccessResponseLog = 'paymentSuccessResponse'
export const paymentSubmitLog = 'paymentSubmit'
export const paymentErrorResponseLog = 'paymentErrorResponse'
export const paymentLogGroup = 'paymentLogGroup'
export const paymentIframeLog = 'paymentIframeSrc'
export const paymentStopListeningResponseLog = 'paymentStopListeningResponseLog'
export const paymentEnterEventListenerLog = 'paymentEnterEventListenerLog'
export const paymentNoInitMessageLog = 'paymentNoInitMessage'
export const paymentGotInitMessageLog = 'paymentGotInitMessage'
export const openKioskTokenVerifyModal = 'openKioskTokenVerifyModalLog'

export const customFieldFlowNames = {
    USER: 'CUSTOM_FIELD_USER_SITE',
    LEAD: 'CUSTOM_FIELD_LEAD_SITE',
    COURSE_PARENT: 'HUG_PARENT_SITE',
    COURSE_CHILD: 'HUG_CHILD_SITE',
    BOOK_TO_HUG_SITE: 'BOOK_TO_HUG_SITE'
}

export const projectTypes = {
    site: 'site',
    kiosk: 'kioskStandAlone'
}

export const projectTypeMainSlice = {
    [projectTypes.site]: 'site',
    [projectTypes.kiosk]: 'kiosk'
}

export const HEADER_SIGN_IN_CALLER = 'headerSignIn'